import type {
  PerkGrantForm,
  PerkGroup,
} from '../domain/entities/catalog.entity';

/**
 * `GET /admin/catalog/perks` devolve por **capacidade**, mas preset, associação
 * a produto e concessão guardam `perkId` — a forma. Este índice faz o caminho de
 * volta, para as telas que precisam mostrar "que perk é este id".
 */
export interface ResolvedPerk {
  group: PerkGroup;
  form: PerkGrantForm;
}

export function indexPerkForms(
  groups: PerkGroup[] | undefined,
): Map<string, ResolvedPerk> {
  const index = new Map<string, ResolvedPerk>();
  for (const group of groups ?? []) {
    for (const form of group.grantForms) {
      index.set(form.perkId, { group, form });
    }
  }
  return index;
}
